/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import LabTestCategoryItem from './lab-test-category-item';
import LabTestCategoryItemDetail from './lab-test-category-item-detail';
import LabTestCategoryItemUpdate from './lab-test-category-item-update';
import LabTestCategoryItemDeleteDialog from './lab-test-category-item-delete-dialog';

const LabTestCategoryItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<LabTestCategoryItem />} />
    <Route path="new" element={<LabTestCategoryItemUpdate />} />
    <Route path=":id">
      <Route index element={<LabTestCategoryItemDetail />} />
      <Route path="edit" element={<LabTestCategoryItemUpdate />} />
      <Route path="delete" element={<LabTestCategoryItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default LabTestCategoryItemRoutes;
